import type { SessionUser } from '@tandemone/types'
import { createContext } from 'react'

type CompanyType = 'supplier' | 'buyer'

type FormState = {
  companyName: string
  companyType: CompanyType | null
  firstName: string
  lastName: string
  email: string
  password: string
  confirmPassword: string
  error: string
  submitting: boolean
}

type Action =
  | { type: 'SET_COMPANY_NAME'; payload: string }
  | { type: 'SET_COMPANY_TYPE'; payload: CompanyType }
  | { type: 'SET_FIRST_NAME'; payload: string }
  | { type: 'SET_LAST_NAME'; payload: string }
  | { type: 'SET_EMAIL'; payload: string }
  | { type: 'SET_PASSWORD'; payload: string }
  | { type: 'SET_CONFIRM_PASSWORD'; payload: string }
  | { type: 'SET_ERROR'; payload: string }
  | { type: 'CLEAR_ERROR' }
  | { type: 'SUBMIT_START' }

type SignupContextType = {
  state: FormState
  dispatch: React.Dispatch<Action>
  googleUser: SessionUser | null
  slug: string
  isValid: boolean
  handleSubmit: (e: React.SyntheticEvent) => void
}

export const SignupContext = createContext<SignupContextType | null>(null)

export type { Action, CompanyType, FormState, SignupContextType }
